import cfdTradingContent from "./content/cfd-trading.json";

export const cfdTradingMock = {
  name: "cfd-trading",
  layoutType: 1,
  areasList: [
    {
      id: "cfd-trading-1",
      name: "cfd-trading-content",
      componentName: "Comp:CfdTradingPage",
      content: JSON.stringify(cfdTradingContent),
    },
  ],
};
